module.exports = __webpack_public_path__ + "img/header-diamondJewelryCollectionRings@2x.971bbc5.webp";